import React from 'react';

const Breaker = () => (
  <div style={{ borderTop: '1px #ddd solid', width: 80, margin: '50px auto' }} />
);

export default Breaker;
